import { render, staticRenderFns } from "./PaymentMessage.vue?vue&type=template&id=5a824492&scoped=true&"
import script from "./PaymentMessage.vue?vue&type=script&lang=js&"
export * from "./PaymentMessage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMessage.vue?vue&type=style&index=0&id=5a824492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a824492",
  null
  
)

export default component.exports